<ol class="breadcrumb" *transloco="let t;">
    <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs | async" let-last=last let-data="breadcrumb.label">
        <li class="breadcrumb-item" *ngIf="breadcrumb.label.title"
            [ngClass]="{active: last}">
            <a *ngIf="!last" [routerLink]="breadcrumb.url">{{ t(breadcrumb.label.title, breadcrumb.label) }}</a>
            <span *ngIf="last" [routerLink]="breadcrumb.url">{{ t(breadcrumb.label.title, breadcrumb.label) }}</span>
        </li>
    </ng-template>
    <ng-content></ng-content>
</ol>